import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Buildings, Storefront, Martini, Sparkle, ArrowRight } from '@phosphor-icons/react';

const LocationPartenaires = () => {
  const profiles = [
    {
      icon: Buildings,
      title: 'Agences événementielles',
      description: 'Intégrez nos bars design à vos productions événementielles.'
    },
    {
      icon: Storefront,
      title: 'Traiteurs',
      description: 'Complétez vos prestations avec un élément scénographique fort.'
    },
    {
      icon: Martini,
      title: 'Professionnels du bar',
      description: 'Disposez de structures premium pour vos services.'
    },
    {
      icon: Sparkle,
      title: 'Partenaires scénographiques',
      description: 'Associez nos créations à vos univers créatifs.'
    }
  ];

  return (
    <div className="bg-black min-h-screen">
      {/* Hero with Background Image */}
      <section className="relative min-h-[60vh] flex items-center justify-center">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/om2elofe_ChatGPT%20Image%2011%20mai%202026%20a%CC%80%2011_26_00.png"
            alt="Équipe Studio Bar"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        
        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center px-6 lg:px-12 py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white mb-4">
              Location & partenaires
            </h1>
            <div className="w-16 h-px bg-white/50 mx-auto mt-6"></div>
            <p className="text-sm uppercase tracking-wider text-white/70 mt-6">Professionnels</p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="section-white py-16 px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-20"
          >
            <h2 className="font-display text-3xl lg:text-4xl text-black mb-8">
              Une offre dédiée aux professionnels de l'événementiel
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
            {/* Text Content */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <p className="text-xl lg:text-2xl text-black leading-relaxed mb-8">
                STUDIO BAR met à disposition ses bars scénographiés auprès des agences, traiteurs et professionnels du bar souhaitant intégrer un élément design fort à leurs prestations.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8">
                Pensées pour être modulaires, esthétiques et opérationnelles, nos structures s'adaptent à vos contraintes techniques et à vos univers créatifs.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8">
                Chaque bar est conçu comme un élément scénographique à part entière.
              </p>
              <p className="text-black font-medium border-l-2 border-black pl-6 mb-10">
                Accès réservé aux professionnels.
              </p>
              <Link to="/projet?type=professionnel" className="btn-primary-dark inline-flex items-center gap-2">
                Accès professionnel direct
                <ArrowRight size={16} weight="light" />
              </Link>
            </motion.div>

            {/* Image */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="aspect-[4/5] overflow-hidden bg-black">
                <img
                  src="https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/b8uvvd7g_Capture%20d%E2%80%99e%CC%81cran%202026-05-11%20a%CC%80%2011.33.51.png"
                  alt="Location bars professionnels"
                  className="w-full h-full object-cover"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Profiles Section */}
      <section className="bg-black py-32 px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-display text-3xl lg:text-4xl text-white mb-4">
              Profils concernés
            </h2>
            <div className="w-12 h-px bg-white/30 mx-auto"></div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {profiles.map((profile, index) => (
              <motion.div
                key={profile.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="p-8 border border-white/10 hover:border-white/30 transition-colors"
              >
                <profile.icon size={32} weight="thin" className="text-white mb-6" />
                <h3 className="font-display text-xl text-white mb-3">{profile.title}</h3>
                <p className="text-white/60 leading-relaxed">{profile.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LocationPartenaires;
